import { useEffect } from "react";
import Ud1000EditModal from "./components/Ud1000EditModal";
import Ud1000SummaryTable from "./components/Ud1000SummaryTable";

/*
 * Ud1000Report 역할:
 * - UD1000 이미지 리포트의 요약 테이블과 진단 이미지를 한 화면에 구성한다.
 * - 읽기 전용 화면과 편집 모달이 같은 데이터 흐름을 공유하도록 표시값을 정리한다.
 * - 편집 모드에서는 보고서 초안 필드와 판정 결과를 수정하고 저장 액션으로 연결한다.
 *
 * 처리 흐름:
 * 1. 읽기/편집 모드에 맞춰 화면에 표시할 리포트 데이터와 판정 라벨을 계산한다.
 * 2. 편집 모달이 열리면 ESC 닫기와 body 클래스 토글을 연결한다.
 * 3. 요약 테이블과 편집 모달 컴포넌트를 현재 모드에 맞춰 조합한다.
 */
export default function Ud1000ReportTypeImg({
  file,
  isReadOnly,
  form,
  t,
  imgTemp,
  previewScale = 1,
  fusionLabels,
  fileFusionCode,
  toFusionCode,
  handleChange,
  handleFusionResultChange,
  ultrasonicRef,
  thermalRef,
  fftRef,
  uvRef,
  setIsReadOnly,
  onSave,
  isSaving = false,
  hasChanges = false,
}) {
  // STEP 1: 읽기/편집 모드에 따라 화면에 표시할 리포트 데이터와 판정 텍스트를 정리한다.
  const draftData = isReadOnly ? { ...(file ?? {}), ...(form ?? {}) } : file;
  const displayFusionCode = toFusionCode(
    draftData?.fusion_result_code ?? draftData?.fusion_result,
    fileFusionCode,
  );
  const displayFusionLabel =
    fusionLabels?.[displayFusionCode] ??
    draftData?.fusion_result ??
    file?.fusion_result ??
    "";

  // STEP 2: 편집 모달이 열려 있는 동안 ESC 닫기와 body 상태 클래스를 동기화한다.
  useEffect(() => {
    if (!isReadOnly) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsReadOnly(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    document.body.classList.add("reportEditModalOpen");

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("reportEditModalOpen");
    };
  }, [isReadOnly, setIsReadOnly]);

  // STEP 3: 리포트 본문과 편집 모달을 분리된 컴포넌트로 조합해 렌더링한다.
  return (
    <>
      <Ud1000SummaryTable
        draftData={draftData}
        file={file}
        t={t}
        imgTemp={imgTemp}
        previewScale={previewScale}
        displayFusionLabel={displayFusionLabel}
        ultrasonicRef={ultrasonicRef}
        thermalRef={thermalRef}
        fftRef={fftRef}
        uvRef={uvRef}
      />

      {isReadOnly ? (
        <Ud1000EditModal
          t={t}
          form={form}
          handleChange={handleChange}
          handleFusionResultChange={handleFusionResultChange}
          toFusionCode={toFusionCode}
          fileFusionCode={fileFusionCode}
          fusionLabels={fusionLabels}
          setIsReadOnly={setIsReadOnly}
          onSave={onSave}
          isSaving={isSaving}
          hasChanges={hasChanges}
        />
      ) : null}
    </>
  );
}
